import { toast } from "react-toastify";
import CustomToast from "./CustomToast";

const showToast = (type, message) => {
  toast(<CustomToast type={type} message={message} />, {
    //   position: toast.POSITION.TOP_RIGHT,
    autoClose: 2000, // Duration in ms
    hideProgressBar: true,
    closeOnClick: true,
    draggable: false,
  });
};

export default showToast;
